<ngx-ui-loader></ngx-ui-loader>
<app-header></app-header>
<main [@routeAnimations]="prepareRoute(outlet)">
<router-outlet  #outlet="outlet"></router-outlet>
</main>
<!-- 
<app-view-users></app-view-users> -->